import { CAMPAIGNS_PER_PAGE } from '../../utils/config';
import createReducer from '../../utils/createReducer';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
  list: [],
  hasMore: false,
  single: null,
  requesting: false,
  error: null,
  loadingMore: false,
  loadMoreError: null,
};

const campaigns = createReducer(initialState, {
  // get list
  [actionTypes.CAMPAIGNS_GET_LIST_REQUEST](state) {
    return { ...state, requesting: true, error: null };
  },
  [actionTypes.SET_REQUESTING](state, { payload }) {
    return { ...state, requesting: payload };
  },
  [actionTypes.CAMPAIGNS_GET_LIST_ERROR](state, { payload }) {
    return { ...state, error: payload, requesting: false };
  },
  [actionTypes.CAMPAIGNS_GET_LIST_STORE](state, { payload }) {
    return {
      ...state,
      list: [...payload],
      hasMore: Boolean(payload.length === CAMPAIGNS_PER_PAGE),
      requesting: false,
      error: null,
    };
  },
  // load more
  [actionTypes.CAMPAIGNS_LOAD_MORE_REQUEST](state) {
    return { ...state, loadingMore: true, loadMoreError: null };
  },
  [actionTypes.CAMPAIGNS_LOAD_MORE_ERROR](state, { payload }) {
    return { ...state, loadMoreError: payload, loadingMore: false };
  },
  [actionTypes.CAMPAIGNS_LOAD_MORE_APPEND](state, { payload }) {
    return {
      ...state,
      list: [...state.list, ...payload],
      hasMore: Boolean(payload.length === CAMPAIGNS_PER_PAGE),
      loadingMore: false,
      loadMoreError: null,
    };
  },
  // campaign
  [actionTypes.CAMPAIGNS_GET_SINGLE_REQUEST](state) {
    return { ...state, requesting: true, error: null };
  },
  [actionTypes.CAMPAIGNS_GET_SINGLE_ERROR](state, { payload }) {
    return { ...state, error: payload, requesting: false };
  },
  [actionTypes.CAMPAIGNS_GET_SINGLE_STORE](state, { payload }) {
    return {
      ...state,
      single: payload,
      requesting: false,
      error: null,
    };
  },
  // add new campaign
  [actionTypes.CAMPAIGNS_ADD_NEW_REQUEST](state) {
    return { ...state, requesting: true, error: null };
  },
  [actionTypes.CAMPAIGNS_ADD_NEW_SUCCESS](state, { payload }) {
    return {
      ...state,
      list: [...state.list, payload],
      requesting: false,
      error: null,
    };
  },
  [actionTypes.CAMPAIGNS_ADD_NEW_ERROR](state, { payload }) {
    return { ...state, error: payload, requesting: false };
  },
  // remove from list
  [actionTypes.CAMPAIGNS_REMOVE_FROM_LIST](state, { payload }) {
    return {
      ...state,
      list: [...state.list.filter((x) => x.id !== payload.id)],
    };
  },
});

export default campaigns;

export const getList = (state) => state.campaigns.list;
export const getIsHasMore = (state) => state.campaigns.hasMore;
export const getSingle = (state) => state.campaigns.single;
export const getIsRequesting = (state) => state.campaigns.requesting;
export const getError = (state) => state.campaigns.error;
export const getIsLoadingMore = (state) => state.campaigns.loadingMore;
export const getLoadMoreError = (state) => state.campaigns.loadMoreError;
